import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Mail } from 'lucide-react';
import { toast } from 'sonner';

export const SendPdfDialog = ({ open, onOpenChange, title, description, defaultEmail = '', onSend, testId = 'send-pdf' }) => {
  const [email, setEmail] = useState(defaultEmail);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (open) {
      setEmail(defaultEmail || '');
      setMessage('');
    }
  }, [open, defaultEmail]);

  const submit = async () => {
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      toast.error('Ievadiet derīgu e-pasta adresi');
      return;
    }
    setSending(true);
    try {
      const result = await onSend(email, message || null);
      toast.success(result?.message || 'Nosūtīts');
      onOpenChange(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Neizdevās nosūtīt');
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={`${testId}-dialog`}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Mail className="w-5 h-5 text-[#1F3D2B]" /> {title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label>E-pasta adrese</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vards@epasts.lv" data-testid={`${testId}-email`} />
          </div>
          <div className="space-y-1">
            <Label>Ziņojums (neobligāti — tiks izmantots standarta teksts)</Label>
            <Textarea rows={3} value={message} onChange={(e) => setMessage(e.target.value)} data-testid={`${testId}-message`} />
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} data-testid={`${testId}-cancel`}>Atcelt</Button>
            <Button onClick={submit} disabled={sending} className="bg-[#1F3D2B] hover:bg-[#2a5039]" data-testid={`${testId}-submit`}>
              {sending ? 'Sūta...' : 'Nosūtīt PDF'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SendPdfDialog;
